/* Prepinac poctu sloupcu ve vypisu produktu 4 / 5 (2026-08-10)
   ==================================================================
   Patri k assets/vg-card-grid.css, sekce 26i. Vklada se ze snippets/
   vg-custom.liquid s atributem defer.

   Rozdeleni prace mezi hlavicku a tenhle soubor je zamerne:
   - Kratky skript primo v <head> (snippets/vg-custom.liquid) jen precte
     ulozenou volbu a nastavi tridu vg-cols-4 na <html>. Musi byt inline
     a bez defer, jinak by se stranka vykreslila v peti sloupcich a pak
     preskocila na ctyri.
   - Tady zustava jen obsluha kliknuti a dorovnani aria-pressed, coz
     pockat muze.

   Volba se drzi na <html>, ne na mrizce. Mrizku pri filtrovani a razeni
   prepisuje component-facets.js (nahrazuje obsah #CollectionProductGrid),
   takze trida na ni by po kazdem filtru zmizela. <html> zustava, takze
   neni co obnovovat.

   Posluchac kliknuti je jeden na celem dokumentu (delegace) - prezije
   proto i vymenu obsahu mrizky a nemusi se po prekresleni znovu vesat.
   MutationObserver hlida jen dorovnani aria-pressed pro pripad, ze
   editor motivu prekresli celou sekci i s prepinacem. Stejny postup
   pouziva snippets/vg-custom.liquid, cast 5. */

(function () {
  var KEY = 'vg_cols_mode';
  var FOUR = 'vg-cols-4';

  function read() {
    try {
      return window.localStorage.getItem(KEY) === '4' ? '4' : '5';
    } catch (e) {
      return '5';
    }
  }

  /* aria-pressed rika ctecce, ktera moznost je zvolena. Vzhled tlacitka
     resi CSS podle tridy na <html>, tady se dorovnava jen pristupnost. */
  function syncButtons() {
    var mode = document.documentElement.classList.contains(FOUR) ? '4' : '5';
    var btns = document.querySelectorAll('.vg-cols-toggle__btn');
    for (var i = 0; i < btns.length; i++) {
      var want = btns[i].getAttribute('data-vg-cols') === mode ? 'true' : 'false';
      if (btns[i].getAttribute('aria-pressed') !== want) {
        btns[i].setAttribute('aria-pressed', want);
      }
    }
  }

  function apply(mode) {
    document.documentElement.classList.toggle(FOUR, mode === '4');
    syncButtons();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.vg-cols-toggle__btn') : null;
    if (!btn) return;
    var mode = btn.getAttribute('data-vg-cols') === '4' ? '4' : '5';
    try {
      window.localStorage.setItem(KEY, mode);
    } catch (e2) {}
    apply(mode);
  });

  /* Pojistka: kdyby skript v hlavicce neprobehl (stara data v mezipameti,
     vypnute uloziste), nastavi se trida jeste jednou tady. */
  apply(read());

  var queued = false;
  function queueSync() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () {
      queued = false;
      syncButtons();
    });
  }

  document.addEventListener('DOMContentLoaded', queueSync);
  new MutationObserver(queueSync).observe(document.documentElement, { childList: true, subtree: true });
})();

/* ====================================================================
   Pocitadlo mnozstvi primo na karte (etapa C, 2026-08-10)
   ====================================================================
   Po pridani do kosiku se kulate "+" promeni v pilulku [kos] [1] [+] ve
   stejnem rohu fotky. Pri jednom kuse je vlevo kos (odebere zbozi),
   od dvou kusu minus. Vzhled je v assets/vg-card-grid.css, sekce 26k.

   PROC SE OBCHAZI <product-form> ZE SABLONY
   Tlacitko na karte je odesilaci tlacitko formulare, ktery obsluhuje
   assets/component-product-form.js: posle /cart/add.js a pak vyvola
   udalost add-to-cart, na kterou component-quick-buy.js otevre bocni
   kosik. U pocitadla primo na karte by to znamenalo vyskakovaci panel
   po kazdem kliknuti - pri ceste na tri kusy trikrat. Klik se proto
   zachyti a zpracuje zde; bocni kosik se neotevira. Na detailu produktu
   se nic nemeni, tam formular bezi po stare ceste - zachytava se jen
   tlacitko uvnitr vypisu kolekce a sekce Doporucujeme.

   KTERA KONCOVKA NA CO
   Pridani jde pres /cart/add.js, protoze bere PRIRUSTEK - jedno kliknuti
   znamena "o jeden vic" bez ohledu na to, jestli je cislo na karte jeste
   platne. Odebrani a snizeni jde pres /cart/update.js, ktere bere
   ABSOLUTNI mnozstvi; jina moznost neni, prirustkova koncovka pro ubytek
   neexistuje. Podrobnosti a proc na tom zalezi viz addDelta a flushOne.

   ZAVODY PRI RYCHLEM KLIKANI
   Cislo na pilulce se prekresli hned (uzivatel neceka), ale pozadavky
   jdou za sebou v jednom retezci promise - nikdy dva najednou. Kliky,
   ktere prijdou behem letu, se scitaji a odejdou v jednom dalsim
   pozadavku. Podrobne viz komentar u serverQty / pendingDelta nize.

   POCET V ZAHLAVI A OBSAH KOSIKU
   Zapis nejde pres component-product-form.js, takze cislo u kosiku v
   zahlavi ani obsah bocniho panelu by se samy neobnovily.
   Dotahuje se proto sekce helper-cart uplne stejne, jako to dela
   sablona - tim se prevezme i spravne formatovana castka a nemusi se
   nikde skladat zapis meny.

   Od 14. 8. 2026 je v rozsahu i titulni strana
   (.collection-tabs_panel), takze pocitadlo na karte funguje i tam. */

(function () {
  var SCOPE = ':is(.collection.grid--layout, .vg-recommended, .collection-tabs_panel)';
  var cartLoaded = false;
  var chain = Promise.resolve();

  /* STAV POCITADLA - SERVEROVA PRAVDA PLUS NEPOTVRZENY ROZDIL
     ------------------------------------------------------------------
     (rychle kliky 2026-08-13, bezpecny zapis 2026-08-13b)

     Drive existovala jedina mapa mnozstvi. Klik do ni pricetl 1 a odpoved
     serveru ji CELOU prepsala. Jenze odpoved nese stav k okamziku, kdy
     pozadavek ODCHAZEL, ne kdy dorazil. Kdyz mezi dvema kliky dorazila
     odpoved na ten prvni, srazila pocitadlo zpatky a dalsi klik uz
     pocital ze stare hodnoty:

        t=0    klik -> 1, odesila se 1
        t=120  klik -> 2, odesila se 2
        t=150  odpoved na prvni pozadavek: kosik ma 1 -> mapa zpet na 1
        t=240  klik -> 1+1 = 2 misto 3, odesila se 2
        vysledek: kosik 2

     Chyba se projevila jen kdyz odpoved stihla dorazit MEZI dvema kliky,
     tedy pri rozestupu RTT/2 az RTT. Nad RTT se odpoved vratila drive nez
     dalsi klik, pod RTT/2 odesly vsechny kliky drive nez prvni odpoved -
     proto rychle klikani pusobilo spolehlive a vina padla na prohazovani
     tlacitka za pilulku.

     Nove se drzi zvlast:
       serverQty     posledni jistota ze serveru (meni ji jen server),
       pendingDelta  soucet kliku, ktere server jeste nepotvrdil,
       sendingDelta  rozdil, ktery je prave na ceste.

     Zobrazuje se jejich soucet. Odpoved uz nemuze prepsat rozklikanou
     hodnotu a naopak rozklikana hodnota nebrani tomu, aby se stav srovnal
     podle serveru - dorovna se i kdyz kosik zmeni neco jineho: druha
     zalozka, bocni kosik, odebrani polozky nebo dokoncena objednavka.

     PROC ROZDIL A NE CILOVE MNOZSTVI
     Klik znamena "o jeden vic", ne "chci presne sest". Kdyby se drzelo
     cilove cislo, stacilo by aby karta ukazovala zastarale mnozstvi
     (kosik se mezitim vyprazdnil jinde) a jedno kliknuti by do kosiku
     zapsalo to stare cislo plus jedna - zakaznik by omylem objednal sest
     kusu misto jednoho. Rozdil je proti zastaralemu zobrazeni odolny,
     viz addDelta a flushOne nize. */
  var serverQty = {};
  var pendingDelta = {};
  var sendingDelta = {};
  var flushQueued = false;

  /* Bezi prave nase vlastni obnova #AjaxCartForm (refreshCartUI)?
     Slouzi jako pojistka proti smycce - podrobne viz blok "dorovnani po
     zmene kosiku jinde na strance" na konci souboru. */
  var selfWriting = false;

  function deltaOf(id) {
    return (pendingDelta[id] || 0) + (sendingDelta[id] || 0);
  }

  function shownQty(id) {
    var q = (serverQty[id] || 0) + deltaOf(id);
    return q > 0 ? q : 0;
  }

  /* HISTORIE: pocitadlo na karte byvalo vyhradne desktopova vec. Jeho
     vzhled sedel v assets/vg-card-grid.css, sekci 26k, uvnitr @media od
     1024 px a pod tuhle hranici musela karta zustat presne jak byla:
     tlacitko "Pridat do kosiku" odeslalo formular sablony pres
     assets/component-product-form.js a otevrel se bocni kosik.

     Posluchac nize se proto musel na mobilu vypnout - mobilni tlacitko
     ma tutez tridu .vg-cart-icon-btn (bss-custom.css ho do 767 px jen
     roztahne na celou sirku a doplni popisek), takze by mu preventDefault
     sebral puvodni chovani.

     Od 2026-08-20 uz toto rozdeleni neplati: klient chce stejnou kartu
     na obou sirkach, mobilni vzhled pribyl v sekci 26q a pojistka nize
     je vyrazena natvrdo. */
  /* 2026-08-20: pojistka zrusena. Klient chce pocitadlo i na mobilu -
     karta ma i tam zacinat kulatym "+" a po kliknuti se rozbalit do
     pilulky. Vzhled pro uzke displeje pribyl v assets/vg-card-grid.css,
     sekce 26q, vcetne prebiti mobilnich pravidel z bss-custom.css
     (roztazene tlacitko na celou sirku a popisek "Pridat do kosiku").

     Funkce se nechava na miste misto smazani volani nize - kdyby se
     nekdy melo chovani zase rozdelit podle sirky, staci vratit sem
     puvodni test na (min-width: 1024px) a nic jineho se nehleda. */
  function isDesktop() {
    return true;
  }

  var ICON_TRASH = '<svg class="vg-qty__ic vg-qty__ic--trash" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18"/><path d="M8 6V4h8v2"/><path d="M19 6l-1 14H6L5 6"/></svg>';
  var ICON_MINUS = '<svg class="vg-qty__ic vg-qty__ic--minus" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" aria-hidden="true"><path d="M5 12h14"/></svg>';
  var ICON_PLUS = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';

  function routes() {
    return (window.KROWN && window.KROWN.settings && window.KROWN.settings.routes) || {};
  }

  /* --- vykresleni ------------------------------------------------- */

  function variantOf(wrap) {
    var input = wrap.querySelector('input[name="id"]');
    /* Obal na detailu produktu (.vg-detail-buy, viz assets/vg-detail-buy.js)
       zadny vlastni input nema - zamerne. Cte se primo z formulare na
       strance, takze prepnuti varianty je videt hned a nic se nemusi
       kopirovat ani synchronizovat. */
    if (!input && wrap.classList.contains('vg-detail-buy')) {
      input = document.querySelector('.main-product .product-form input[name="id"]');
    }
    return input ? input.value : null;
  }

  /* Pilulka se doplni do kazde karty, ktera ma tlacitko do kosiku.
     U vicevariantnich produktu je misto tlacitka odkaz na detail a u
     vyprodanych neni nic - obe karty se preskoci. */
  function ensurePill(wrap) {
    var pill = wrap.querySelector('.vg-qty');
    if (pill) return pill;
    pill = document.createElement('div');
    pill.className = 'vg-qty';
    pill.innerHTML =
      '<button type="button" class="vg-qty__btn" data-vg-qty="down" aria-label="Odebrat kus">' + ICON_TRASH + ICON_MINUS + '</button>' +
      '<span class="vg-qty__n" aria-live="polite">0</span>' +
      '<button type="button" class="vg-qty__btn" data-vg-qty="up" aria-label="Pridat kus">' + ICON_PLUS + '</button>';
    wrap.appendChild(pill);
    return pill;
  }

  function paintCard(wrap) {
    var id = variantOf(wrap);
    if (!id) return;
    var qty = shownQty(id);
    var pill = ensurePill(wrap);
    pill.setAttribute('data-qty', qty);
    pill.querySelector('.vg-qty__n').textContent = qty;
    pill.querySelector('[data-vg-qty="down"]').setAttribute(
      'aria-label', qty > 1 ? 'Odebrat kus' : 'Odstranit z kosiku'
    );
    wrap.classList.toggle('vg-has-qty', qty > 0);
  }

  /* Dva druhy obalu se stejnym chovanim: karta ve vypisu a kulate
     tlacitko na detailu produktu. Vsude, kde se obaly hledaji, se pouziva
     tenhle jeden retezec, at na nej nikdo pri dalsi uprave nezapomene. */
  var WRAPS = SCOPE + ' .product-item .product-item__quick-buy, .vg-detail-buy, .product-related-item__button';

  function paintAll() {
    var wraps = document.querySelectorAll(WRAPS);
    for (var i = 0; i < wraps.length; i++) paintCard(wraps[i]);
  }

  /* --- kosik ------------------------------------------------------- */

  /* Server je jediny zdroj pravdy. Nepotvrzene kliky (pendingDelta,
     sendingDelta) se tu zamerne NESAHA - odectou se az kdyz odpoved
     dorazi, jinak by dorovnani snedlo rozklikane cislo. */
  function readCartInto(cart) {
    serverQty = {};
    if (cart && cart.items) {
      for (var i = 0; i < cart.items.length; i++) {
        var it = cart.items[i];
        serverQty[it.variant_id] = (serverQty[it.variant_id] || 0) + it.quantity;
      }
    }
    paintAll();
  }

  /* cache: 'no-store' je tu zamerne. Bez nej muze prohlizec na opakovany
     GET /cart.js vratit odpoved z pameti a dorovnani po navratu na
     zalozku by stav "obnovilo" na to same zastarale cislo. */
  function fetchCart() {
    return fetch((routes().cart_url || '/cart') + '.js', {
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    }).then(function (r) { return r.json(); });
  }

  function loadCart() {
    return fetchCart()
      .then(function (cart) { cartLoaded = true; readCartInto(cart); })
      .catch(function (e) { console.log(e); });
  }

  /* Obnova zahlavi a bocniho kosiku presne tak, jak to dela
     assets/component-product-form.js - vcetne prepocitane castky. */
  function refreshCartUI() {
    /* Od tehle chvile az do dobehnuti prepisu jsme to my, kdo meni obsah
       #AjaxCartForm. Cizi udalost o zmene kosiku se po tu dobu jen
       poznamena - viz pumpCartSync nize. */
    selfWriting = true;
    return fetch('?section_id=helper-cart')
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');

        var newForm = doc.getElementById('AjaxCartForm');
        var curForm = document.getElementById('AjaxCartForm');
        if (newForm && curForm) {
          curForm.innerHTML = newForm.innerHTML;
          if (typeof curForm.ajaxifyCartItems === 'function') curForm.ajaxifyCartItems();
        }

        var newSub = doc.getElementById('AjaxCartSubtotal');
        var curSub = document.getElementById('AjaxCartSubtotal');
        if (newSub && curSub) curSub.innerHTML = newSub.innerHTML;

        var count = doc.querySelector('[data-cart-count]');
        if (count) {
          document.querySelectorAll('[data-header-cart-count]').forEach(function (el) {
            el.textContent = count.textContent;
          });
        }
        var total = doc.querySelector('[data-cart-total]');
        if (total) {
          document.querySelectorAll('[data-header-cart-total]').forEach(function (el) {
            el.textContent = total.textContent;
          });
        }
      })
      .catch(function (e) { console.log(e); })
      .then(function () {
        /* Okno vlastniho zapisu konci tady, a to i kdyz obnova spadla -
           .catch vyse chybu spolkne, takze tenhle .then bezi vzdy. Bez
           toho by priznak zustal viset a uz zadna cizi zmena kosiku by
           se neprojevila. */
        selfWriting = false;
        pumpCartSync();
      });
  }

  /* PRIDANI: /cart/add.js bere PRIRUSTEK, ne cilove mnozstvi. Diky tomu
     nemuze zastarale cislo na karte zapsat do kosiku nesmysl - kdyz
     zakaznik mezitim kosik vysypal jinde, jedno kliknuti prida jeden kus,
     ne "posledni videne cislo plus jedna". Zadne predchozi cteni kosiku
     tedy neni potreba a nezustava skulina mezi ctenim a zapisem.

     Navic add.js na rozdil od update.js hlida skladovou dostupnost -
     dokumentace Ajax API u update.js vyslovne upozornuje, ze u polozek,
     ktere uz v kosiku jsou, mnozstvi proti skladu nekontroluje.

     Odpoved nese radky kosiku s NOVYM celkovym mnozstvim, takze se z ni
     rovnou prevezme serverova pravda a neni potreba dalsi dotaz. */
  function addDelta(id, delta) {
    var addUrl = routes().cart_add_url || ((routes().cart_url || '/cart') + '/add');
    return fetch(addUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: delta }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add.js ' + r.status);
        return r.json();
      })
      .then(function (res) {
        var items = (res && res.items) ? res.items : [res];
        var seen = {};
        for (var i = 0; i < items.length; i++) {
          var it = items[i];
          if (!it || it.variant_id == null) continue;
          /* Jedna varianta muze v kosiku lezet na vice radcich (ruzne
             vlastnosti radku), proto se scita stejne jako v readCartInto.
             Kdyby takovy druhy radek vznikl jinde nez tady a add.js ho
             nevratil, ukaze karta mensi cislo nez kosik - do dalsiho
             dorovnani. Objednavku to neohrozi: pridava se prirustkem,
             takze mensi zobrazene cislo neznamena mensi zapis. */
          if (!seen[it.variant_id]) {
            seen[it.variant_id] = 1;
            serverQty[it.variant_id] = 0;
          }
          serverQty[it.variant_id] += it.quantity;
        }
      });
  }

  /* SNIZENI A ODEBRANI: prirustkova koncovka pro ubytek neexistuje,
     /cart/update.js bere absolutni mnozstvi. Nula je bezpecna vzdy - vic
     nez vyprazdnit radek se stat nemuze. */
  function pushTarget(id, qty) {
    var updates = {};
    updates[id] = qty;
    return fetch((routes().cart_update_url || '/cart/update') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { readCartInto(cart); });
  }

  /* --- kliknuti ---------------------------------------------------- */

  function clearBusy() {
    document.querySelectorAll('.vg-qty.is-busy').forEach(function (el) {
      el.classList.remove('is-busy');
    });
  }

  /* Odesila nepotvrzene rozdily, dokud nejaky zbyva. Posila se VZDY cely
     nasbirany rozdil, ne jednotlive kliky - pet kliku behem jednoho letu
     se slouci do jedineho pozadavku s mnozstvim 5.

     Klik, ktery prijde behem letu, se neztrati: pricte se do pendingDelta
     a odesle ho dalsi kolo. Do te doby je videt v sendingDelta, takze
     cislo na pilulce mezitim neposkoci dolu a hned zpatky. */
  function flushOne(id) {
    var delta = pendingDelta[id] || 0;
    delete pendingDelta[id];
    if (!delta) return Promise.resolve();

    sendingDelta[id] = delta;

    var done = function () { delete sendingDelta[id]; };
    var failed = function (e) {
      console.log(e);
      delete sendingDelta[id];
      /* Zamer se pri chybe zahazuje a stav se nacte znovu ze serveru.
         Opakovat by bylo horsi: kdyz se ztratila jen odpoved a zapis
         presto prosel, opakovane add.js by pridalo zbozi dvakrat. Radeji
         jeden nezapsany klik nez tichy prebytek v objednavce. */
      return loadCart();
    };

    if (delta > 0) return addDelta(id, delta).then(done, failed);

    var target = (serverQty[id] || 0) + delta;
    if (target <= 0) {
      /* Zakaznik dosel na nulu - "odstranit z kosiku". Absolutni nula je
         bezpecna i kdyz je zobrazene cislo zastarale. */
      return pushTarget(id, 0).then(done, failed);
    }

    /* Snizeni na kladne cislo je jediny pripad, kdy se posila absolutni
       mnozstvi vetsi nez nula. Nejdriv se proto precte skutecny stav a
       vysledek se opre o nej - jinak by "o jeden min" nad zastaralou
       petkou zapsalo do prazdneho kosiku ctyri kusy. Jeden dotaz navic tu
       stoji za to, snizovani z vyssiho poctu je vzacne. */
    return fetchCart().then(function (cart) {
      readCartInto(cart);
      var t = (serverQty[id] || 0) + delta;
      return pushTarget(id, t < 0 ? 0 : t);
    }).then(done, failed);
  }

  function drain(wrote) {
    var ids = Object.keys(pendingDelta);
    if (!ids.length) {
      flushQueued = false;
      clearBusy();
      /* Zahlavi a bocni kosik se obnovuji az na konci serie, ne po kazdem
         kliknuti. Jeden dotaz misto peti a hlavne kratsi kolo, takze se
         stihne slouceni dalsich kliku. */
      /* Kdyz se nakonec nic nezapisovalo, refreshCartUI vubec nebezi a
         okno vlastniho zapisu konci uz tady - poznamenanou cizi zmenu
         kosiku je proto treba dotahnout odsud. */
      if (!wrote) pumpCartSync();
      return wrote ? refreshCartUI() : Promise.resolve();
    }
    return flushOne(ids[0]).then(function () {
      paintAll();
      return drain(true);
    });
  }

  function scheduleFlush() {
    if (flushQueued) return;
    flushQueued = true;
    /* .catch drzi retez ziv: kdyby jedno kolo skoncilo vyjimkou, zustal
       by chain zamitnuty a uz zadny dalsi zapis by neprosel. */
    chain = chain
      .then(function () { return drain(false); })
      .catch(function (e) {
        console.log(e);
        flushQueued = false;
        clearBusy();
      });
  }

  function change(wrap, delta) {
    var id = variantOf(wrap);
    if (!id) return;

    /* Pod nulu se nescita - jinak by se nasbiral zaporny rozdil, ktery by
       pozdeji snedl platne kliknuti na plus. */
    if (delta < 0 && shownQty(id) <= 0) return;

    pendingDelta[id] = (pendingDelta[id] || 0) + delta;
    paintAll();

    /* Ztlumeni po dobu zapisu davame jen kartam ve vypisu. Na detailu je
       pilulka velka a hlavni ovladaci prvek, takze skoro sekundove
       zesvetleni (nez dobehne /cart/change a obnova bocniho kosiku) cte
       jako zaseknuti, ne jako prace - klient to tak 2026-08-20 nahlasil.
       Cislo se prekresluje optimisticky hned pri kliknuti, takze zpetna
       vazba nechybi. */
    var pill = wrap.querySelector('.vg-qty');
    if (pill && !wrap.classList.contains('vg-detail-buy')) pill.classList.add('is-busy');

    scheduleFlush();
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    /* Drive se pod 1024 px nezachytavalo nic a klik si prevzala sablona.
       Od 2026-08-20 plati stejne chovani na vsech sirkach - viz
       isDesktop vyse. */
    if (!isDesktop()) return;

    var scoped = e.target.closest(SCOPE + ' .product-item .product-item__quick-buy')
      || e.target.closest('.vg-detail-buy')
      || e.target.closest('.product-related-item__button');
    if (!scoped) return;

    /* Kulate "+" ze sablony: nesmi odeslat formular, jinak by se zbozi
       pridalo dvakrat a otevrel by se bocni kosik. */
    var addBtn = e.target.closest('.vg-cart-icon-btn');
    if (addBtn && addBtn.tagName !== 'A') {
      e.preventDefault();
      e.stopPropagation();
      change(scoped, 1);
      return;
    }

    var step = e.target.closest('[data-vg-qty]');
    if (step) {
      e.preventDefault();
      e.stopPropagation();
      change(scoped, step.getAttribute('data-vg-qty') === 'up' ? 1 : -1);
    }
  }, true);

  /* --- start a preziti prekresleni mrizky --------------------------- */

  var queued = false;
  function run() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () {
      queued = false;
      if (cartLoaded) paintAll();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector(WRAPS)) loadCart();
  });

  /* Filtrovani a razeni vymeni cely obsah #CollectionProductGrid, takze
     pilulky zmizi. Kosik uz je v pameti, staci prekreslit. */
  new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true });

  /* Navrat na zalozku: kosik se mohl mezitim zmenit uplne jinde - v jine
     zalozce, v bocnim kosiku nebo dokoncenou objednavkou. Nacte se proto
     znovu, aby karty neukazovaly duchy. Nepotvrzene kliky zustavaji, ty
     dorovna drain.

     Tri spoustece, protoze zadny sam o sobe nestaci:
       visibilitychange  prepnuti zalozky uvnitr okna,
       pageshow          navrat tlacitkem zpet z bfcache, kdy uz
                         DOMContentLoaded neprobehne,
       focus             navrat do prohlizece z jine aplikace, kdy se
                         viditelnost zalozky nemeni.

     Prepnuti zalozky spusti visibilitychange i focus tesne po sobe. */
  var syncing = null;

  function resync() {
    if (!cartLoaded) return Promise.resolve();
    if (!document.querySelector(WRAPS)) return Promise.resolve();
    /* Slucuje se podle rozdelaneho dotazu, ne podle casoveho okna. Dvojice
       visibilitychange + focus tim splyne do jednoho dotazu, ale dve
       oddelene udalosti kratce po sobe se uz nezahodi - casove okno by
       tu druhou spolklo a stav by zustal stary. */
    if (syncing) return syncing;
    var clear = function () { syncing = null; };
    syncing = loadCart().then(clear, clear);
    return syncing;
  }

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) resync();
  });
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) resync();
  });
  window.addEventListener('focus', function () { resync(); });

  /* --- dorovnani po zmene kosiku jinde na strance -------------------
     (nahlaseno 15. 8. 2026)

     CHYBA
     Zakaznik pridal zbozi z karet a pak ho odebral v bocnim kosiku nebo
     na strance /cart. Pilulka na karte dal ukazovala stare mnozstvi a
     srovnala se az kdyz zalozka znovu dostala zamereni.

     PROC
     Prekresleni po vymene mrizky (MutationObserver -> run -> paintAll)
     kresli z ULOZENEHO serverQty, kosik znovu necte. A protoze
     assets/component-cart.js po kazde zmene mnozstvi dotahne
     ?section_id=helper-cart a prepise innerHTML #AjaxCartForm, DOM se
     zmeni, nas pozorovatel se probudi - a poctive vykresli stara cisla
     znovu. Dorovnani totiz viselo jen na DOMContentLoaded,
     visibilitychange, pageshow a focus; zadna z techto udalosti pri
     zmene ve stejne zalozce neprijde.

     NA CO SE VESA
     assets/component-cart.js na konci CartForm.updateCartQty dela:

         const event = new Event('cart-updated');
         this.dispatchEvent(event);

     Udalost tedy prijde po KAZDE zmene mnozstvi i po odebrani polozky,
     v bocnim kosiku i na strance /cart - obe verze snippetu
     (snippets/cart-form.liquid, snippets/cart-form-page.liquid)
     renderuji tyz prvek <cart-form id="AjaxCartForm">, takze obe jedou
     pres tuhle jednu tridu. Spolehlivy signal tedy existuje a neni
     potreba hlidat prepis markupu kosiku pozorovatelem.

     Posloucha se na dokumentu v ZACHYTAVACI fazi. new Event('cart-updated')
     je bez bubbles, nahoru tedy neprobubla - zachytavaci faze ale
     probiha vzdy, od window dolu k cili, takze se udalost zachyti.
     Oproti posluchaci povesenemu primo na #AjaxCartForm to prezije i
     vymenu celeho prvku (editor motivu, shopify:section:load) a nemusi
     se nikde znovu vesat. Stejnou zachytavaci delegaci pouziva i
     posluchac kliknuti vyse.

     POJISTKA PROTI SMYCCE
     Nase vlastni refreshCartUI dotahuje tyz ?section_id=helper-cart a
     prepisuje tyz innerHTML. Kdyby se na vysledek vlastniho zapisu
     reagovalo dorovnanim, vzniklo by nekonecne kolo dotazu.

     Vlastni obnova sice cart-updated sama nevyvolava (dispatch je jen
     uvnitr updateCartQty), ale spolehat se jen na to by bylo krehke.
     Hlavne ale hrozi jina, horsi vec: kdyby dorovnani bezelo soucasne s
     nasim vlastnim zapisem, mohla by odpoved na GET /cart.js dorazit AZ
     PO odpovedi na nas /cart/add.js a prepsat cerstve serverQty stavem,
     ktery platil pred pridanim. Karta by pak ukazovala o kus min, dokud
     by nekdo neprepnul zalozku - tedy presne ta chyba, kterou opravujeme.

     Cizi udalost se proto behem naseho vlastniho zapisu jen POZNAMENA
     (cartDirty) a zpracuje se az potom. Okno vlastniho zapisu je presne
     vymezene: zacina prvnim klikem (flushQueued nastavuje scheduleFlush),
     drzi po cely retez zapisu a konci az dobehne refreshCartUI
     (selfWriting).

     PROC TO NEMUZE ZATUHNOUT
       - flushQueued shazi drain v koncove vetvi a chybova vetev
         scheduleFlush; jedna z nich nastane vzdy.
       - selfWriting shazi refreshCartUI ve svem poslednim .then, ktery
         bezi i po chybe, protoze mu predchazi .catch.
       - obe mista pak sama zavolaji pumpCartSync, takze poznamenana
         zmena se dotahne a priznak nezustane viset.

     PROC SE ZADNA ZMENA NEZTRATI
     cartDirty se shazi az TESNE PRED odeslanim dotazu, ne po nem. Kdyz
     behem letu dorazi dalsi cizi zmena, nastavi priznak znovu a
     pumpCartSync dotaz po dobehnuti zopakuje. Bez toho by ji slucovani
     pres syncing spolklo - resync vraci rozdelany slib a ten uz nese
     stav k okamziku, kdy dotaz ODCHAZEL, ne kdy dorazil (tenhle rozdil
     stal za chybou rychlych kliku, viz serverQty vyse).

     CO TIM NENI POKRYTO
     Zapisy, ktere jdou mimo CartForm.updateCartQty - tedy window.refreshCart
     pro aplikace a add-to-cart z <product-form> (na mobilu a na detailu
     produktu). Pilulka je vyhradne desktopova a na desktopu si pridani z
     karty bere tenhle skript sam, takze se to nahlasene chyby netyka.
     Na takovy stav dal staci dorovnani pri navratu do zalozky. */
  var cartDirty = false;

  function pumpCartSync() {
    if (!cartDirty) return;
    /* Behem vlastniho zapisu se ceka - dotahne to refreshCartUI ve svem
       zaverecnem .then, pripadne drain, kdyz se nakonec nezapisovalo. */
    if (flushQueued || selfWriting) return;
    /* Uz nejake dorovnani leti. Jeho odpoved nese stav starsi nez tato
       zmena, takze se na nej jen navesime a zeptame se znovu az dobehne.
       syncing v te chvili uz bude prazdne - clear uvnitr resync je na
       tomtez slibu povesen driv. */
    if (syncing) { syncing.then(pumpCartSync); return; }
    cartDirty = false;
    resync().then(pumpCartSync);
  }

  document.addEventListener('cart-updated', function () {
    cartDirty = true;
    pumpCartSync();
  }, true);

  /* Pristup pro overeni v konzoli. Rucne vyvolane udalosti se chovaji
     jinak nez ty od prohlizece - u pageshow nejde nastavit persisted a
     visibilitychange se slucuje s focusem - takze bez tohoto by se
     dorovnani nedalo spolehlive otestovat. Pro beh stranky to neni
     potreba, nic z toho sama nevola. */
  window.vgCardQty = {
    resync: resync,
    state: function () {
      return {
        serverQty: serverQty,
        pendingDelta: pendingDelta,
        sendingDelta: sendingDelta,
        /* Priznaky dorovnani po cizi zmene kosiku - aby slo v konzoli
           overit, ze se udalost zachytila a ze priznak vlastniho zapisu
           nezustal viset. */
        cartDirty: cartDirty,
        selfWriting: selfWriting
      };
    }
  };
})();